/*
 * @Author: your name
 * @Date: 2022-03-08 15:09:45
 * @LastEditTime: 2022-03-15 13:36:42
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\www\src\pages\personal\editpwd\locales.ts
 */
export const EnumPageMeta: IEnumPageMeta = {
  /** 页面名称 */
  title: '修改密码',
  login: true,
  layout: 'personal',
};
/**
 * 字段描述 枚举
 */
export enum EnumLocaleLabel {
  /** 姓名 */
  endpoint = 'editpwd.endpoint',
  imgCode = 'editpwd.imgCode',
  verificationCode = 'editpwd.verificationCode',
  oldPwd = 'editpwd.oldPwd',
  newPwd = 'editpwd.newPwd',
  password = 'editpwd.password',
  confirmpwd = 'editpwd.confirmpwd',
  username = 'editpwd.username',
}
export enum EnumGender {}
export default {
  en: {
    [EnumLocaleLabel.endpoint]: 'endpoint',
    [EnumLocaleLabel.imgCode]: 'imgCode',
    [EnumLocaleLabel.verificationCode]: 'verificationCode',
    [EnumLocaleLabel.oldPwd]: 'oldPwd',
    [EnumLocaleLabel.newPwd]: 'newPwd',
    [EnumLocaleLabel.password]: 'password',
    [EnumLocaleLabel.confirmpwd]: 'confirmpwd',
    [EnumLocaleLabel.username]: 'username',
  },
  zh: {
    [EnumLocaleLabel.endpoint]: '手机号',
    [EnumLocaleLabel.imgCode]: '图形验证码',
    [EnumLocaleLabel.verificationCode]: '短信验证码',
    [EnumLocaleLabel.oldPwd]: '旧密码',
    [EnumLocaleLabel.newPwd]: '新密码',
    [EnumLocaleLabel.password]: '新密码',
    [EnumLocaleLabel.confirmpwd]: '确认密码',
    [EnumLocaleLabel.username]: '登录账号',
  },
};
